
<template>
  <Stack v-if="items.length > 1" :cards="items" @update:modelValue="updateIndex" ref="stack" class="gmf-item-stack" stackWidth="90%" :cardWidth="180" >
    <template v-slot:card="{ card }">
      <ListItem :item="card.raw" :canClick="false" :showIfOwned="false" :showPrice="showPrice" />
    </template>
    <template v-slot:nav="{ activeCardIndex, next, previous }">
      <nav class="gmf-card-stack-nav">
        <div
          v-if="items.length > 1"
          :style="{ opacity: activeCardIndex === 0 ? 0 : 1 }"
          class="gmf-card-stack-nav-left"
          @click="previous"
          @touchstart.stop.prevent="previous"
        >
          <Icon icon="chevron_left" />
        </div>
        <div
          v-if="items.length > 1"
          :style="{ opacity: activeCardIndex === items.length - 1 ? 0 : 1 }"
          class="gmf-card-stack-nav-right"
          @click="next"
          @touchstart.stop.prevent="next"
        >
          <Icon icon="chevron_right" />
        </div>
      </nav>
    </template>
  </Stack>
  <div v-else-if="items.length > 0" class="gmf-item-stack-single">
    <ListItem :item="items[0]" :canClick="false" :showIfOwned="false" :showPrice="showPrice" />
  </div>
  <div v-if="items.length > 1" class="gmf-subheader gmf-item-stack-page gmf-mt-2">{{modelValue + 1}}/{{ items.length }}</div>
</template>
<style>
.gmf-card-stack-wrapper .gmf-card-stack-nav {
  display: flex;
  justify-content: center;
}

.gmf-item-stack .gmf-item-container {
  height: 100%;
  width: 100%;
  border: unset;
}

.gmf-item-stack-single {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: var(--gmf-p-3);
}

.gmf-item-stack-single .gmf-item-container {
  width: 180px;
  height: 220px;
}

.gmf-card-stack-nav {
  user-select: none;
}

.gmf-item-stack-page {
  text-align: center;
}

.gmf-card-stack-nav-left,
.gmf-card-stack-nav-right {
  top: 125px;
  z-index: 999;
  position: absolute;
  background-color: var(--gmf-col-white);
  padding: var(--gmf-p-1);
  border-radius: var(--gmf-rounding);
  display: flex;
  cursor: pointer;
}

.gmf-card-stack-nav-left .gmf-icon,
.gmf-card-stack-nav-right .gmf-icon {
  --gmf-icon-color: var(--gmf-col-black);
  height: 30px;
  width: 30px;
}

.gmf-card-stack-nav-left {
  left: 0;
}

.gmf-card-stack-nav-right {
  right: 0;
}
</style>
<script>
import Icon from '../Icon.vue';
import Stack from '../Stack.vue';
import ListItem from './ListItem.vue';

export default {
  props: {
    /**
     * The items to display in the stack.
     */
     items: {
      type: Array,
      default: () => []
    },
    /**
     * The index of the currently selected item.
     */
    modelValue: {
      type: Number,
      default: 0
    },
    showPrice: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    next () {
      this.$refs.stack?.next();
    },
    previous () {
      this.$refs.stack?.previous();
    },
    updateIndex (index) {
      this.$emit('update:modelValue', index);
    },
  },
  components: { Stack, Icon, ListItem }
};
</script>